import * as Types      from '../mutationTypes';
import HestiaApi       from '@/api';
import { cacheAction } from 'vuex-cache';

// initial state
const state = {
  offers : {
    results    : [],
    pagination : {
      perPage : 10,
      page    : 1,
      total   : 0
    }
  }
};

// getters
const getters = {
  offers : state => state.offers
};

// actions
const actions = {
  async getOffers({ commit }, { tenantId, query }) {

    const response = await HestiaApi.Property.offer.list(tenantId, { searchParams : query }).json();

    commit(Types.RECEIVE_OFFERS, response);
  },
  setOffers({ commit }, offers) {

    commit(Types.RECEIVE_OFFERS, offers);
  },
  async addOffer({ commit }, { tenantId, propertyId, offer }) {

    const response = await HestiaApi.Property.offer.create(tenantId, propertyId, offer).json();

    commit(Types.ADD_OFFER, response);
  },
  async editOffer({ commit }, { tenantId, propertyId, id, offer }) {

    const response = await HestiaApi.Property.offer.update(tenantId, propertyId, id, offer).json();

    commit(Types.EDIT_OFFER, response);
  },
  'getPropertyOffers' : cacheAction((_, { tenantId, query }) => {

    return HestiaApi.Property.offer.list(tenantId, { searchParams : query }).json();
  })
};

// mutations
const mutations = {
  [Types.RECEIVE_OFFERS](state, offers) {

    state.offers = offers;
  },
  [Types.ADD_OFFER](state, offer) {

    state.offers.results.push(offer);
  },
  [Types.EDIT_OFFER](state, offer) {

    const index = state.offers.results.findIndex((of) => of.id === offer.id);
    state.offers.results.splice(index, 1, offer);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
